if (!customElements.get('aven-contour-community')) {
  customElements.define('aven-contour-community', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.aven-community__track');
      this.photos = [...this.querySelectorAll('[data-community-open]')];
      this.navigation = this.querySelector('.aven-community__navigation');
      this.previous = this.querySelector('[data-community-prev]');
      this.next = this.querySelector('[data-community-next]');
      this.dialog = this.querySelector('dialog');
      this.fullPhoto = this.querySelector('[data-community-full]');
      this.status = this.querySelector('[data-community-status]');
      this.index = 0;
      if (!this.track || !this.dialog || !this.photos.length) return;
      this.previous.addEventListener('click', () => this.scrollPhotos(-1), options);
      this.next.addEventListener('click', () => this.scrollPhotos(1), options);
      this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
      this.photos.forEach((photo, index) => photo.addEventListener('click', () => {
        this.opener = photo;
        this.showPhoto(index);
        if (!this.dialog.open) this.dialog.showModal();
      }, options));
      this.querySelector('[data-community-close]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-community-dialog-prev]').addEventListener('click', () => this.showPhoto(this.index - 1), options);
      this.querySelector('[data-community-dialog-next]').addEventListener('click', () => this.showPhoto(this.index + 1), options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showPhoto(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
      this.observer = new ResizeObserver(() => this.updateNavigation());
      this.observer.observe(this.track);
      this.updateNavigation();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
    }
    scrollPhotos(direction) {
      const card = this.track.querySelector('.aven-community__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateNavigation() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.navigation.hidden = maximum <= 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
    }
    showPhoto(index) {
      this.index = (index + this.photos.length) % this.photos.length;
      const photo = this.photos[this.index];
      this.fullPhoto.src = photo.dataset.fullSrc;
      this.fullPhoto.alt = photo.dataset.photoAlt;
      this.status.textContent = `${this.index + 1} of ${this.photos.length}`;
    }
  });
}
